import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  stateOptions: Object[] = [{ label: 'Admin', value: 'admin' }, { label: 'Supervisor', value: 'supervisor' }, { label: 'Operator', value: 'operator' }];
  account: string = "admin";
  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  routeTologin(): void {
    this.router.navigate(['/login'])
  }
}
